import { DialogWrapper } from 'components/dialogWrapper'
import { Loader } from 'components/loader'
import { Img } from 'components/image'
import { Dispatch, SetStateAction } from 'react'
import { useCategoryContent } from 'hooks/category-manage'
import { useGetEpisodeDetails } from 'hooks/episode'

interface ViewEpisodeDialogProps {
    isOpen: boolean
    setIsOpen: Dispatch<SetStateAction<boolean>>
    episodeData: any | null
}

const ViewEpisodeDialog = ({
    isOpen,
    setIsOpen,
    episodeData,
}: ViewEpisodeDialogProps) => {
    const { data, isLoading: isFetching } = useGetEpisodeDetails(episodeData?.id)
    if (!isOpen) return null
    const episode = data?.data?.results || {}

    return (
        <DialogWrapper
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            title="Engagement Details"
        >
            <div className="space-y-4 p-2">
                {/* ===========================
          SHOW INFORMATION
      =========================== */}
                <div className="p-4 rounded-lg">
                    {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <p className="text-sm text-gray-500">{episode?.uniqueViews?.label ?? '—'}</p>
                            <p className="font-medium">{episode?.uniqueViews?.value ?? '—'}</p>
                        </div>

                        <div>
                            <p className="text-sm text-gray-500">{episode?.totalViews?.label ?? '—'}</p>
                            <p className="font-medium">{episode?.totalViews?.value ?? '—'}</p>
                        </div>
                        {/* <div>
                            <p className="text-sm text-gray-500">{category?.durationOfEpisodesWatched?.label ?? '—'}</p>
                            <p className="font-medium">{category?.durationOfEpisodesWatched?.value ?? '—'}</p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-500">{episode?.averageEpisodeCompletion?.label ?? '—'}</p>
                            <p className="font-medium">{episode?.averageEpisodeCompletion?.value ?? '—'}</p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-500">{episode?.resourceSaved?.label ?? '—'}</p>
                            <p className="font-medium">{episode?.resourceSaved?.value ?? '—'}</p>
                        </div>

                        <div>
                            <p className="text-sm text-gray-500">{episode?.bookmarkedPercentage?.label ?? '—'}</p>
                            <p className="font-medium">{episode?.bookmarkedPercentage?.value ?? '—'}</p>
                        </div>
                        <div>
                            <p className="text-sm text-gray-500">{episode?.numberOfLikes?.label ?? '—'}</p>
                            <p className="font-medium">{episode?.numberOfLikes?.value ?? '—'}</p>
                        </div>
                         <div>
                            <p className="text-sm text-gray-500">{episode?.returnVisits7Day?.label ?? '—'}</p>
                            <p className="font-medium">{episode?.returnVisits7Day?.value ?? '—'}</p>
                        </div>
                         <div>
                            <p className="text-sm text-gray-500">{episode?.returnVisits30Day?.label ?? '—'}</p>
                            <p className="font-medium">{episode?.returnVisits30Day?.value ?? '—'}</p>
                        </div>
                    </div> */}

                    <table className="w-full border border-gray-300 border-collapse rounded-lg">
                        <tbody>
                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {episode?.uniqueViews?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {episode?.uniqueViews?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {episode?.totalViews?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {episode?.totalViews?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {episode?.averageEpisodeCompletion?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {episode?.averageEpisodeCompletion?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {episode?.resourceSaved?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {episode?.resourceSaved?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {episode?.bookmarkedPercentage?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {episode?.bookmarkedPercentage?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {episode?.numberOfLikes?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {episode?.numberOfLikes?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {episode?.returnVisits7Day?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {episode?.returnVisits7Day?.value ?? '—'}
                                </td>
                            </tr>

                            <tr>
                                <td className="px-4 py-3 text-sm text-gray-500 border border-gray-300 dark:text-white">
                                    {episode?.returnVisits30Day?.label ?? '—'}
                                </td>
                                <td className="px-4 py-3 font-medium border border-gray-300">
                                    {episode?.returnVisits30Day?.value ?? '—'}
                                </td>
                            </tr>
                        </tbody>
                    </table>



                </div>

                {/* ===========================
          EPISODES SECTION
      =========================== */}
                {/* Episodes (selected in Create Show) */}
                {/* Episodes Section */}
                <div className="flex justify-end pt-4">
                    <button
                        onClick={() => setIsOpen(false)}
                        className="px-4 py-2 bg-gray-200 rounded bg-gray-300 dark:bg-slate-700 text-gray-800 dark:text-slate-200
"
                    >
                        Close
                    </button>
                </div>
            </div>
        </DialogWrapper>
    )
}

export default ViewEpisodeDialog
